mutation RestoreOrganizations($ids: [ID!]!) {
  restoreOrganizations(ids: $ids) {
    id
    deleted
    updatedAt
  }
}

